import { Alert } from 'antd';
import { FormInstance } from 'antd/lib/form';
import isEqual from 'lodash/isEqual';
import React, { memo } from 'react';
import { useDeepCompareEffect } from 'react-use';

import DefaultForm from 'components/composites/DefaultForm';
import DefaultFormItem from 'components/composites/DefaultFormItem';
import EnterpriseFormItems from 'components/forms/EnterpriseFormItems';
import { useErrorMessage } from 'store/modules/loading/hooks';
import Enterprise from 'types/models/enterprise';

interface Props {
  /** e.g., 'EDIT_BACK_OFFICE_ENTERPRISE_REQUEST', 'ADD_BACK_OFFICE_ENTERPRISE_REQUEST' */
  actions: string[];
  form: FormInstance;
  initialValues?: Partial<Enterprise>;
  readOnly?: boolean;
}

function BackOfficeEnterpriseForm({
  actions,
  form,
  initialValues,
  readOnly
}: Props): JSX.Element | null {
  const errorMessage = useErrorMessage(actions);

  useDeepCompareEffect(() => {
    form.resetFields();
  }, [form, initialValues]);

  return (
    <DefaultForm
      form={form}
      layout="vertical"
      name="backOfficeEnterprise"
      autoComplete="chrome-off"
      initialValues={initialValues}
      requiredMark={!readOnly && 'optional'}
      closeDrawerOnSubmit
      closeDrawerIfFieldsAreValid={false}
    >
      <EnterpriseFormItems
        isBackOffice
        showSubdomainField
        initialValues={initialValues}
        readOnly={readOnly}
      />
      {errorMessage && (
        <DefaultFormItem>
          <Alert message={errorMessage} type="error" />
        </DefaultFormItem>
      )}
    </DefaultForm>
  );
}

export default memo(BackOfficeEnterpriseForm, isEqual);
